import polyglot from '../../../../localization';

import { Description } from './Cards';

import './styles.scss';

/**
 * GameDescription component renders a landing section with an intro text
 * and a set of description cards. All text is localized by the selected language.
 *
 * @param {string} lang — Language key used to localize intro text and card content.
 */

const GameDescription = ({ lang }) => (
    <section className='game-description'>
        <div className='game-description__intro wrapper'>
            <div className='container'>
                <p className='game-description__intro-text'>
                    {polyglot.t(`${lang}.footer.topText`)}
                </p>
            </div>
        </div>

        <Description lang={lang} />
    </section>
);

export default GameDescription;
